import React from 'react';
import c from 'classnames';

import { SearchActiveFacetsProps } from '@uncinc/react-searchkit/dist/components/ActiveFacets';

import SearchActiveFacets from '../../Search/ActiveFacets';

const SearchTopicalActiveFacets: React.FC<Pick<SearchActiveFacetsProps, 'className'>> = (props) => {
  const { className } = props;

  const classNames = c('SearchTopical__ActiveFacets', className);

  return (
    <SearchActiveFacets
      className={classNames}
      // We use type filter just to filter the type of view, not the results,
      // so we hide it from the active facets.
      transformItems={(items) => items.filter((item) => item.attribute !== 'type')}
    />
  );
};

export default SearchTopicalActiveFacets;
